<main class="main-home-secton">
  <div class="event-main">
    <div class="container-fluid">
      <section class="div-header">
        <div class="content-details">
          <div class="title-details">
            <div class="d-flex">
              <h4><ion-icon name="layers-outline"></ion-icon> CSR Project</h4>
              <div class="ml-auto">
                <button
                  mat-raised-button
                  color="primary"
                  (click)="projectAddBtn()"
                >
                  Upload New Project
                </button>
              </div>
            </div>
            <section class="statusbutton">
              <div>
                <button
                  mat-raised-button
                  class="mr-2 all"
                  (click)="ststusBtn(3, 'all')"
                >
                  ALL
                </button>
                <button
                  mat-raised-button
                  class="mr-2 pending"
                  (click)="ststusBtn(0, 'pending')"
                >
                  Pending
                </button>
                <button
                  mat-raised-button
                  class="mr-2 approved"
                  (click)="ststusBtn(1, 'approved')"
                >
                  Approved
                </button>
                <button
                  mat-raised-button
                  class="mr-2 rejected"
                  (click)="ststusBtn(2, 'rejected')"
                >
                  Rejected
                </button>
              </div>
            </section>
          </div>
          <div *ngIf="noData == false">
            <div class="example-container mat-elevation-z8">
              <mat-table
                #table
                [dataSource]="dataSource"
                [class.isMobile]="isMobile"
              >
                <ng-container matColumnDef="index">
                  <mat-header-cell *matHeaderCellDef class="table-no">
                    No.
                  </mat-header-cell>
                  <mat-cell
                    *matCellDef="let element; let i = index"
                    class="table-no"
                  >
                    <span class="mobile-label">No :</span>
                    {{ paginator.pageSize * paginator.pageIndex + i + 1 }}
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="projectName">
                  <mat-header-cell *matHeaderCellDef>
                    Project Name
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <span class="mobile-label">Project Name:</span>
                    {{ element.projectName }}
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="spocName">
                  <mat-header-cell *matHeaderCellDef>SPOC Name</mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <span class="mobile-label">SPOC Name:</span>
                    {{ element.spocName }}
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="spocMobile">
                  <mat-header-cell *matHeaderCellDef>
                    SPOC Mobile</mat-header-cell
                  >
                  <mat-cell *matCellDef="let element">
                    <span class="mobile-label">SPOC Mobile:</span>
                    {{ element.spocMobile }}
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="status">
                  <mat-header-cell *matHeaderCellDef> Status </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <span class="mobile-label">Status :</span>
                    <span *ngIf="element.status == 0" class="Pending"
                      >Pending for Approval</span
                    >
                    <span *ngIf="element.status == 1" class="Approved"
                      >Approved</span
                    >
                    <span *ngIf="element.status == 2" class="Rejected"
                      >Rejected</span
                    >
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="remark">
                  <mat-header-cell
                    *matHeaderCellDef
                    [ngClass]="{ 'd-none': valueGet != '2' && valueGet != 3 }"
                    >Remark</mat-header-cell
                  >
                  <mat-cell
                    *matCellDef="let element"
                    [ngClass]="{ 'd-none': valueGet != '2' && valueGet != 3 }"
                  >
                    <span class="mobile-label">Remark :</span>
                    <span class="eye-icon" *ngIf="element.remark"
                      ><ion-icon
                        name="eye-outline"
                        (click)="
                          viewDescrptionBtn(element.remark, 'View Remark')
                        "
                        class="ml-3"
                      ></ion-icon
                    ></span>
                    <span *ngIf="!element.remark" class="ml-3">-</span>
                  </mat-cell>
                </ng-container>
                <mat-header-row
                  *matHeaderRowDef="displayedColumns"
                ></mat-header-row>
                <mat-row
                  *matRowDef="let row; columns: displayedColumns"
                ></mat-row>
              </mat-table>
            </div>
            <mat-paginator
              #paginator
              class="mat-elevation-z8"
              [length]="pageTotalCount"
              [pageSize]="pageSize"
              [pageSizeOptions]="[10, 15, 20]"
              showFirstLastButtons
              (page)="getServerData($event)"
              aria-label="Select page of periodic elements"
            >
            </mat-paginator>
          </div>
          <div class="text-center no-data-div" *ngIf="noData == true">
            <img
              src="assets/images/startup-logo.png"
              class="img-fluid"
              alt=""
            />
            <h6>No Records Found</h6>
          </div>
        </div>
      </section>
    </div>
  </div>
</main>
